import React from 'react';
import ReactDOM from 'react-dom/client';

/* Tailwind (baru) */
import './index.css';

import { AppSettingProvider } from './context/AppSettingContext';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppSettingProvider>
      <App />
    </AppSettingProvider>
  </React.StrictMode>
);
